import { BannerHeightEnum } from './types/enums';

export const bannerDynamicHeight = (height: string) => {
  switch (height) {
    case BannerHeightEnum.ONE_LINER:
    case BannerHeightEnum.ONE_LINER_MOBILE:
      return 'banner-one-height';
    case BannerHeightEnum.TWO_LINER:
    case BannerHeightEnum.TWO_LINER_MOBILE:
      return 'banner-two-height';
    default:
      return '';
  }
};
